<template>
    <div class="font-gellix insurances-cols">
    <template v-for="category in menu().categories">
        <div v-if="$i18n.locale === 'fr' || ($i18n.locale === 'nl' && category.insurances.filter(insurance => !insurance.hideNL).length)" style="break-inside: avoid;">
            <h4 class="text-sm font-semibold text-emerald-300 py-2 text-left">{{ $t(`shared.products_nav.${properties.type}.${category.i18nKey}.label`) }}</h4>
            <ul class="pb-3">
                <template v-for="insurance in category.insurances">
                <li v-if="$i18n.locale === 'fr' || ($i18n.locale === 'nl' && !insurance.hideNL)"  class="w-full border-b border-b-emerald-100/10 border-opacity-10 lg:border-b-emerald-200 lg:border-opacity-100 last:border-0 py-2">
                    <a :href="$t(`shared.products_nav.${properties.type}.${category.i18nKey}.${insurance.i18nLink}`)" class="flex justify-between items-center rounded-lg py-2 lg:text-emerald-900 w-full hover:text-opacity-70">
                        <div class="flex items-center">
                            <swIcon 
                                :name="`product-types/${insurance.iconKey}`" 
                                size="w-8 h8 text-white lg:text-emerald-900" 
                                :unstyled="true" 
                            />
                            <span class="ml-3 font-semibold text-left">{{ $t(`shared.products_nav.${properties.type}.${category.i18nKey}.${insurance.i18nKey}`) }}</span>
                        </div>
                        <swIcon 
                            :name="`arrow-right-full`" 
                            size="w-4" 
                            :unstyled="false" 
                            class="text-emerald-300"
                        />
                    </a>
                </li>
                </template>
            </ul>
        </div>
    </template>
    </div>
</template>

<script setup lang="ts">
import { privateMenu, MenuType, businessMenu, independentMenu } from '../../utils/navigationSubMenus'

const properties = defineProps<{
  type: MenuType
}>()

const menu = () => {
    switch (properties.type) {
    case 'private':
      return privateMenu
    case 'business':
      return businessMenu
    case 'independent':
      return independentMenu
    default:
      return privateMenu
  }
} 
</script>

<style>
.insurances-cols{ 
    width: 100%
}

@media screen and (min-width: 1024px) {
    .insurances-cols{
        columns: 2; 
        column-gap: 3rem;
        width: 1200px; 
        max-width: 96vw
    }
}

@media screen and (min-width: 1280px) {
    .insurances-cols{
        columns: 3; 
        column-gap: 3rem;
    }
}
</style>